module.exports = __webpack_public_path__ + "assets/img/light-success-tip.3005db0a.svg";